var _defs, _g, _g2, _path, _g3, _path2, _path3, _path4, _path5, _rect, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageRecovery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 384.587,
    height: 324.436,
    viewBox: "0 0 384.587 324.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5793ce;}.b{fill:rgba(62,118,210,0.5);}.c{fill:rgba(38,78,177,0.35);}.d{fill:#d4ecff;}.e{fill:#173d7a;}.f{fill:#fff;}.g{fill:#396caa;}.h{fill:#d3d0cf;}.i{fill:#f2f2f2;}.j{fill:#ffc2b0;}.k{fill:#ea9c92;}.l{fill:#ff4b36;}.m{fill:#274f89;}.n{fill:#dfb61c;}.o,.p{fill:#ffca01;}.p,.q,.r,.s,.t{fill-rule:evenodd;}.q{fill:url(#a);}.r,.u{fill:#545556;}.s{fill:url(#b);}.t{fill:url(#c);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.93,
    y1: 1.001,
    x2: -0.039,
    y2: -0.026,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.93,
    y1: 1.002,
    x2: -0.039,
    y2: -0.026,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.93,
    y1: 1.002,
    x2: -0.039,
    y2: -0.026,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(316.151 288.266)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.501,
    height: 7.265,
    transform: "matrix(0.248, 0.969, -0.969, 0.248, 17.809, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.501,
    height: 7.265,
    transform: "translate(14.219 3.502) rotate(75.627)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.501,
    height: 7.265,
    transform: "translate(10.628 7.005) rotate(75.627)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.501,
    height: 7.265,
    transform: "translate(7.038 10.507) rotate(75.624)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.687 2.821)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M432.04,137.13l-66.055,38.756c-16.747-5.139-38.085-3.551-52.165,4.711-17.131,10.051-17.019,26.153.252,35.964a52.7,52.7,0,0,0,12.995,5.1,69.32,69.32,0,0,0,10.327,1.781c13.738,1.337,28.4-1.113,38.97-7.314,12.8-7.512,15.97-18.4,9.547-27.519l9.115-5.348-.258-5.787,9.592-.067-.242-5.419,9.593-.067-.242-5.42,9.593-.067-.242-5.419,9.592-.067-.241-5.42,10.241-.072,3.125-1.832,3.449-14.228Zm-92.954,74.155c-4.46,2.616-11.721,2.667-16.216.114s-4.526-6.746-.066-9.363,11.721-2.667,16.216-.114S343.546,208.669,339.086,211.285Z",
    transform: "translate(-280.884 -67.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M450.634,352.132,361.548,300.91c-6-3.463-5.246-9.512,1.68-13.51l86.463-49.919c6.926-4,17.4-4.433,23.4-.97l89.086,51.221c6,3.463,5.246,9.511-1.679,13.51l-86.464,49.919C467.108,355.161,456.632,355.594,450.634,352.132Z",
    transform: "translate(-263.341 -37.623)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.416 103.861)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.774)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M531.6,257.975l-15.4-8.892L572.982,216.3c2.682-1.549,2.682-4.069,0-5.617L514.97,177.188a10.762,10.762,0,0,0-9.728,0l-56.786,32.785-15.4-8.892L489.84,168.3c11.174-6.451,29.357-6.451,40.531,0l58.012,33.493c11.174,6.451,11.174,16.949,0,23.4Z",
    transform: "translate(-433.054 -163.458)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M585.08,258.019c0-8.234-5.006-17.8-11.182-21.365l-102.885-59.4c-2.766-1.6-5.293-1.709-7.244-.619l-.005,0L340.918,248.016l118.795,89.516,121.026-70.244a5.6,5.6,0,0,0,1.07-.62h0C583.829,265.135,585.08,262.132,585.08,258.019Z",
    transform: "translate(-337.91 -175.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M435.25,320.888l121.026-70.244a5.6,5.6,0,0,0,1.07-.62h0c2.02-1.531,3.27-4.534,3.27-8.647a27.43,27.43,0,0,0-3.013-11.9L419.644,309.128Z",
    transform: "translate(-313.447 -159.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M452.69,320.444,349.8,261.043c-6.175-3.565-11.181-13.131-11.181-21.364h0c0-8.234,5.006-12.018,11.181-8.453l102.886,59.4c6.175,3.565,11.181,13.13,11.181,21.364h0C463.871,320.225,458.865,324.009,452.69,320.444Z",
    transform: "translate(-338.623 -159.147)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M417.352,286.855l-12.369-7.136a5.337,5.337,0,0,1-2.23-4.259h0c0-1.641,1-2.395,2.23-1.684l12.369,7.136a5.338,5.338,0,0,1,2.228,4.259h0C419.58,286.812,418.583,287.565,417.352,286.855Z",
    transform: "translate(-318.695 -129.26)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M343.029,135.962l21.138,12.008,21.569-12.655-.057-5.5-.184.108-.017-.389,9.593-.067-.057-5.42,9.407-.066-.056-5.42,9.407-.066-.056-5.421,9.407-.066-.056-5.421,10.056-.07,3.125-1.833,3.449-14.228-.057-5.505-1.664,5.275L422.75,89.187Z",
    transform: "translate(-267.838 -83.682)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.861)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.273)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M364.124,143l21.569-12.655-.259-5.786,9.593-.067-.242-5.419,9.593-.067-.242-5.419,9.593-.067-.242-5.419,9.592-.067-.242-5.419,10.242-.072,3.125-1.833,3.448-14.228-16.944-2.263-79.721,46.774Z",
    transform: "translate(-342.985 -84.219)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.273 37.634)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M378.488,125.652a29.72,29.72,0,0,0-9.8-8.446,50.567,50.567,0,0,0-10.125-4.274l-15.579,9.14,21.138,12.008Z",
    transform: "translate(-342.985 -112.931)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.737 1.883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M432.8,88.424l.579-2.388-2.843-.38-67.358,39.521,3.548,2.015Z",
    transform: "translate(-363.176 -85.656)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.006 61.82)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M304.1,139.208l-.233-7.825,2.505,5.285Z",
    transform: "translate(-303.872 -131.383)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M317.074,161.129c17.27,9.811,45.159,9.617,62.29-.435,8.589-5.04,12.841-11.6,12.772-18.125v0l-.24-8.292-1.408,1.569c-1.987-4.087-5.774-7.935-11.379-11.119-17.272-9.811-45.159-9.616-62.29.435S299.8,151.319,317.074,161.129Zm24.947-14.637c4.5,2.555,4.526,6.746.065,9.363s-11.721,2.667-16.216.114-4.526-6.746-.066-9.363S337.525,143.937,342.021,146.491Z",
    transform: "translate(-303.812 -73.878)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M316.894,155.162c17.272,9.811,45.16,9.616,62.291-.435s17.017-26.153-.253-35.964-45.159-9.616-62.29.436S299.624,145.351,316.894,155.162Zm24.949-14.637c4.5,2.553,4.526,6.745.066,9.363s-11.721,2.667-16.216.113-4.526-6.745-.066-9.363S337.347,137.97,341.843,140.525Z",
    transform: "translate(-303.867 -111.531)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M336.863,153.742a17.686,17.686,0,0,1-10.994-1.624c-3.224-1.832-4.138-4.5-2.76-6.836l-7.824-6.2s-4.09-4.614-8.138-9.188c-6.3,9.208-2.983,20.054,9.926,27.388,5.7,3.235,12.076,5.073,19.314,6.138Z",
    transform: "translate(-303.811 -70.027)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M316.894,155.162a52.6,52.6,0,0,0,12.995,5.1,69.147,69.147,0,0,0,10.327,1.783c13.738,1.337,28.4-1.113,38.969-7.314,17.131-10.052,17.017-26.153-.253-35.964s-45.159-9.616-62.29.436S299.624,145.351,316.894,155.162Zm24.949-14.637c4.5,2.553,4.526,6.745.066,9.363s-11.721,2.667-16.216.113-4.526-6.745-.066-9.363S337.347,137.97,341.843,140.525Z",
    transform: "translate(-303.867 -111.531)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.866 38.603)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M307.581,136.677c.84-5.012,4.556-9.909,11.173-13.792,15.243-8.943,40.055-9.116,55.421-.388,7.636,4.339,11.494,10.059,11.582,15.813,1.094-6.534-2.7-13.266-11.4-18.2-15.366-8.73-40.179-8.555-55.421.387C311.27,124.991,307.494,130.852,307.581,136.677Z",
    transform: "translate(-307.58 -113.67)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 60.253)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M304,202.727a17.279,17.279,0,0,1-8.642-2.23c-6.189-3.511-9.634-10.57-9.7-19.875-.122-16.97,11.69-37.765,26.33-46.356,8.02-4.707,15.845-5.365,22.035-1.848a17.307,17.307,0,0,1,6.407,6.407,26.676,26.676,0,0,1,3.289,13.469c.121,16.97-11.693,37.766-26.333,46.356A26.765,26.765,0,0,1,304,202.727Zm21.372-66.3a20.622,20.622,0,0,0-10.228,3.213c-12.929,7.585-23.363,25.951-23.255,40.942.047,6.985,2.371,12.135,6.543,14.5s9.783,1.73,15.807-1.8c12.93-7.585,23.363-25.951,23.258-40.942a20.889,20.889,0,0,0-2.433-10.359h0a10.819,10.819,0,0,0-9.693-5.552Z",
    transform: "translate(-285.663 -130.188)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M322.673,146.9l12.3,3.013,1.766-9.124c-4.459,2.616-11.721,2.667-16.216.113Z",
    transform: "translate(-274.833 -66.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M313.806,145.188a52.6,52.6,0,0,0,12.995,5.1,69.148,69.148,0,0,0,10.327,1.783c13.738,1.337,28.4-1.113,38.97-7.314l-50.074-1.125Z",
    transform: "translate(-276.918 -65.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M330.5,150.305a72.71,72.71,0,0,1-10.875-2.8v7.684a59.648,59.648,0,0,0,10.743,2.754C341.833,159.454,330.5,150.305,330.5,150.305Z",
    transform: "translate(-275.11 -64.554)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M324.12,148.957a51.009,51.009,0,0,1-7.083-2.614c-6.7-3.135,1.775,8.48,1.775,8.48s2.282.91,5.309,1.838Z",
    transform: "translate(-276.715 -65.082)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M425.393,251.236l-21.909,14.13-10.665-1.732,26.05-12.593Z",
    transform: "translate(-224.679 -29.56)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.853 30.455)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.752)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M402.15,305.866s-6.31-3.182-10.186,1.556-9.416,15.927-9.588,23.486,5.982,7.048,9.641,5.259,14.343-17.289,14.991-20.326-.763-7.145-1.792-7.948S402.15,305.866,402.15,305.866Z",
    transform: "translate(-358.53 -43.304)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M401.345,304.816l.292,6.538a3.708,3.708,0,0,1-1.848,3.4,7.271,7.271,0,0,1-4.868.756c-4.754-.764-5.177-2.122-5.518-8.659S401.345,304.816,401.345,304.816Z",
    transform: "translate(-356.348 -43.774)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 115.997)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M384.526,296.275s-6.31-3.182-10.186,1.556-9.416,15.925-9.588,23.484,5.982,7.049,9.64,5.26,14.343-17.289,14.991-20.327-.763-7.143-1.792-7.947S384.526,296.275,384.526,296.275Z",
    transform: "translate(-364.007 -162.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M383.721,295.225l.292,6.538a3.708,3.708,0,0,1-1.848,3.4,7.279,7.279,0,0,1-4.868.756c-4.754-.764-5.179-2.122-5.518-8.659S383.721,295.225,383.721,295.225Z",
    transform: "translate(-361.824 -162.751)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M442.39,206.237c-1.868-30.391-32.913,4.471-32.913,4.471L388.23,231.534,369.1,252.553a18.859,18.859,0,0,0-4.753,15.151l7.74,58.936a5.792,5.792,0,0,0,5.809,5.033,19.551,19.551,0,0,0,2.867-.25,7.2,7.2,0,0,0,6.4-7.64l-1.414-55.123,40.182-24.222S444.257,236.628,442.39,206.237Z",
    transform: "translate(-364.183 -193.799)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M395.983,243.462l-5.717-2.1c-.134,0-9.72,9.272-9.637,12.518l4.3,1.38,10.8-10.485Z",
    transform: "translate(-359.072 -63.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M419.855,257.665s23.879-13.634,26.738-19.35c1.119-2.239,2.859-4.578-4.109-7.961l-31.846,22.7,1.38,7.816Z",
    transform: "translate(-349.747 -66.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M460.014,215.183c-1.991-30.383-32.913,4.472-32.913,4.472l-21.247,20.826L386.72,261.5a18.862,18.862,0,0,0-4.753,15.151l7.741,58.937a5.791,5.791,0,0,0,5.808,5.033,19.738,19.738,0,0,0,2.867-.25,7.2,7.2,0,0,0,6.4-7.642l-1.414-55.122,40.182-24.222S461.834,242.961,460.014,215.183Z",
    transform: "translate(-358.706 -75.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.226,138.5c23.537,9.757,23.065,23.671,23.065,23.671s-4.611,51.006-3.037,85.07c.658,14.241-75.658,15.328-64.277-22.664,13.419-44.794,8.389-81.059,14.671-86.527S432.137,135.971,438.226,138.5Z",
    transform: "translate(-355.284 -96.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M438.862,150c-1.231,4.779-7.492,7.3-13.984,5.626s-10.757-6.9-9.526-11.681,7.492-7.3,13.984-5.624S440.093,145.219,438.862,150Z",
    transform: "translate(-348.348 -95.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M429.119,157.524a17.079,17.079,0,0,1-4.253-.547,15.665,15.665,0,0,1-8.252-5.054,8.99,8.99,0,0,1-2.084-8c1.381-5.373,8.272-8.262,15.354-6.434a15.669,15.669,0,0,1,8.251,5.056,8.989,8.989,0,0,1,2.084,8C439.118,154.823,434.522,157.524,429.119,157.524Zm-3.543-18.337c-4.371,0-8.027,2.034-8.868,5.3a6.812,6.812,0,0,0,1.65,6.014,13.4,13.4,0,0,0,7.068,4.3c5.881,1.51,11.54-.645,12.615-4.814a6.812,6.812,0,0,0-1.65-6.014,13.392,13.392,0,0,0-7.068-4.3A15.093,15.093,0,0,0,425.576,139.187Z",
    transform: "translate(-348.616 -95.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M420.31,138s.2.944-.2,8.4c-.128,2.345,8.082,4.535,10.2,2.413s1.273-4.329,1.783-12.309S420.31,138,420.31,138Z",
    transform: "translate(-346.805 -96.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M432.093,135.744s-2.022,7.4-11.988,10.237l.151-6.725Z",
    transform: "translate(-346.805 -95.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M442.522,124.623a18.117,18.117,0,1,1-22.075-13.005A18.118,18.118,0,0,1,442.522,124.623Z",
    transform: "translate(-350.921 -103.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M429.172,126.407s-9.975,4.273-16.881,4.322-5.385-5.734-5.385-5.734l20.5-2.964Z",
    transform: "translate(-350.951 -100.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M412.1,132.731s8.689-3.688,16.312-2.151a7.985,7.985,0,0,1,4.606,2.738,2.719,2.719,0,0,0,1.395,1.008c1.351.307,3.564-5.3,6.192-5.429s4.381,1.731,2.226,5.181-1.426,7.309-.434,7.862,11.5-7.5,2.231-25.87-32.831-8.477-36.5-4.753c0,0-3.86,3.362-7,.37C401.132,111.687,397.613,138.044,412.1,132.731Z",
    transform: "translate(-352.818 -105.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M442.132,186.043v13.782a5.618,5.618,0,0,1-1.832,4.15l-28.313,25.812,3.217,4.921,37.39-27.118a7.6,7.6,0,0,0,3.1-5.357l2.527-24.036Z",
    transform: "translate(-349.328 -82.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.686,150.495s8.589,12.917,11.789,46.921c0,0-14.672,4.745-23,2.051S446.686,150.495,446.686,150.495Z",
    transform: "translate(-342.671 -91.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M434.631,162.956s-3.363,18-3.553,26.455a5.4,5.4,0,0,0,3.553,5.214h0Z",
    transform: "translate(-343.396 -87.386)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.526 136.847)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M448.125,237.075l-6.257-.826-40.4-23.322a5.617,5.617,0,0,0-5.053.208l-28.624,16.521-3.783-.5v3.767h0a1.476,1.476,0,0,0,.869,1.326l45.78,26.431a5.614,5.614,0,0,0,5.052-.21l31.173-17.991a2.039,2.039,0,0,0,1.236-1.7h0Z",
    transform: "translate(-364.009 -208.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M417.773,220.38l-2.871-1.657H383.351L367.795,227.7l-3.783-.5v3.767h0a1.476,1.476,0,0,0,.869,1.326l45.78,26.431a4.729,4.729,0,0,0,2.607.488Z",
    transform: "translate(-364.009 -206.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M365.691,225.411l-1.679-.222v3.767h0a1.476,1.476,0,0,0,.869,1.326l.807.465Z",
    transform: "translate(-364.009 -204.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M399.955,250.986a5.868,5.868,0,0,0,4.294-.266v-6.41h-4.294Z",
    transform: "translate(-352.841 -198.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M410.664,257.76l-45.78-26.431c-1.3-.748-1.132-2.054.363-2.918l31.172-17.991a5.617,5.617,0,0,1,5.053-.21l45.78,26.431c1.295.748,1.132,2.054-.363,2.918l-31.173,17.991A5.614,5.614,0,0,1,410.664,257.76Z",
    transform: "translate(-364.01 -209.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M408.21,251.464l-38.065-21.977c-1.077-.621-.942-1.707.3-2.425l16.7-9.394a4.669,4.669,0,0,1,4.2-.173l38.066,21.976c1.076.623.941,1.708-.3,2.426l-16.7,9.393A4.665,4.665,0,0,1,408.21,251.464Z",
    transform: "translate(-362.33 -207.416)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M390.261,209.966l-.474,3.159a23.353,23.353,0,0,0,.207,8.1l.564,2.784a3.914,3.914,0,0,0,3.137,3.075h0a2.159,2.159,0,0,0,2.532-1.885l.755-6.753s1.728,2.265,2.563,2.265-.933-6.763-2.821-10.591S390.261,209.966,390.261,209.966Z",
    transform: "translate(-351.555 -73.272)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M406.31,173.548l-4.913,9.723a19.05,19.05,0,0,0-2.009,7.379L397.254,223.9l-6.462-.153-2.933-37.344a13.723,13.723,0,0,1,.167-3.452l3.352-18.938Z",
    transform: "translate(-352.086 -87.057)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 117.045)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M410,264.992l-3.839-5.011-40.367-23.37a5.615,5.615,0,0,1-2.338-4.484l.034-33.048-2.32-3.03,2.18-1.264,0,0a1.471,1.471,0,0,1,1.583.09l45.747,26.487a5.613,5.613,0,0,1,2.338,4.483l-.038,35.992a2.039,2.039,0,0,1-.856,1.919h0Z",
    transform: "translate(-360.368 -194.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M382.081,246.042l-2.868-1.661-15.742-27.343.016-17.958-2.32-3.03,2.18-1.264,0,0a1.471,1.471,0,0,1,1.583.09l45.747,26.487a4.738,4.738,0,0,1,1.724,2.016Z",
    transform: "translate(-360.368 -194.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M362.2,197.394l-1.029-1.345,2.18-1.264,0,0a1.471,1.471,0,0,1,1.583.09l.806.467Z",
    transform: "translate(-360.368 -194.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M400.374,215.244a5.863,5.863,0,0,1,1.911,3.854l-4.471,2.581-2.142-3.72Z",
    transform: "translate(-349.645 -188.184)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M408.69,222.329l-45.746-26.486c-1.295-.75-2.346.043-2.348,1.77l-.039,35.992a5.62,5.62,0,0,0,2.34,4.484l45.747,26.486c1.294.75,2.345-.043,2.348-1.77l.038-35.992A5.613,5.613,0,0,0,408.69,222.329Z",
    transform: "translate(-360.557 -194.3)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M418.016,222.478,417.283,224a10.166,10.166,0,0,1-3.823,4.239l-4.544,2.8a4.525,4.525,0,0,1-4.639.107l-.155-.093a2.735,2.735,0,0,1-.387-4.2l4.749-4.881s-2.667,2.043-3.416,1.22c-.548-.6,2.587-3.547,5-3.643a9.5,9.5,0,0,0,4.736-1.988Z",
    transform: "translate(-347.389 -70.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M411.046,137.3s-17.408,18.941-24.43,36.318c0,0,5.952,10.724,20.523,14.932S411.046,137.3,411.046,137.3Z",
    transform: "translate(-352.46 -95.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M400.68,182l2.822-27.255-6.648,25.536A37.809,37.809,0,0,0,400.68,182Z",
    transform: "translate(-349.278 -89.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M416.311,134.684l-4.678-1.285s2.234,3.513,5.493,4.408,3.767-1.864,3.767-1.864Z",
    transform: "translate(-344.686 -96.571)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M350.574,108.647a13.1,13.1,0,1,1,13.1-13.1A13.117,13.117,0,0,1,350.574,108.647Zm0-23.346a10.243,10.243,0,1,0,10.242,10.243A10.254,10.254,0,0,0,350.574,85.3Z",
    transform: "translate(-241.877 -81.951)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M551.757,178.871a9.291,9.291,0,1,1,9.29-9.291A9.3,9.3,0,0,1,551.757,178.871Zm0-15.722a6.431,6.431,0,1,0,6.43,6.432A6.439,6.439,0,0,0,551.757,163.149Z",
    transform: "translate(-178.178 -57.76)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M318.634,307.063l-6.307-12.826,12.826-6.306,6.307,12.826Zm-2.48-11.523,3.783,7.7,7.7-3.783-3.783-7.7Z",
    transform: "translate(-249.691 -18.097)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M460.66,155.389l-6.306-12.828,12.826-6.306,6.306,12.827Zm-2.48-11.524,3.783,7.7,7.7-3.783-3.781-7.7Z",
    transform: "translate(-205.558 -65.228)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 6.571,
    height: 6.571,
    transform: "translate(45.823 213.646) rotate(-26.18)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.492)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M489.855,102.629,454.809,82.395A1.793,1.793,0,0,0,453,82.249l0-.022-3.4,1.963,2.389.873v25.523a6.755,6.755,0,0,0,2.819,5.388l33.5,19.34v3l3.434-1.978-.018-.007a2.5,2.5,0,0,0,.953-2.248v-26.06A6.752,6.752,0,0,0,489.855,102.629Z",
    transform: "translate(-448.527 -82.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M486.648,137.734,451.6,117.5a6.754,6.754,0,0,1-2.821-5.387V86.052c0-2.076,1.264-3.032,2.821-2.133l35.047,20.235a6.754,6.754,0,0,1,2.821,5.387V135.6C489.469,137.679,488.205,138.633,486.648,137.734Z",
    transform: "translate(-448.781 -81.596)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.876 22.504)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M461.046,103.655c0,1.507-1.059,2.119-2.366,1.364a5.227,5.227,0,0,1-2.365-4.095c0-1.509,1.059-2.119,2.365-1.366A5.225,5.225,0,0,1,461.046,103.655Z",
    transform: "translate(-456.316 -99.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M466.511,106.81c0,1.509-1.059,2.119-2.365,1.366a5.225,5.225,0,0,1-2.365-4.1c0-1.507,1.058-2.119,2.365-1.366A5.231,5.231,0,0,1,466.511,106.81Z",
    transform: "translate(-454.618 -98.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M471.976,109.966c0,1.507-1.058,2.118-2.365,1.364a5.227,5.227,0,0,1-2.365-4.1c0-1.507,1.059-2.118,2.365-1.364A5.223,5.223,0,0,1,471.976,109.966Z",
    transform: "translate(-452.919 -97.275)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 222.106)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M304.836,271.69l-34.382-19.85a1.757,1.757,0,0,0-1.777-.143l0-.022-3.336,1.927,2.344.856V279.5a6.623,6.623,0,0,0,2.767,5.285l32.863,18.974v2.937l3.37-1.94-.018-.007a2.452,2.452,0,0,0,.935-2.2V276.976A6.626,6.626,0,0,0,304.836,271.69Z",
    transform: "translate(-264.291 -251.518)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M301.689,306.13l-34.382-19.851a6.624,6.624,0,0,1-2.767-5.286V255.428c0-2.038,1.239-2.974,2.767-2.092l34.382,19.851a6.623,6.623,0,0,1,2.767,5.285v25.566C304.456,306.075,303.217,307.012,301.689,306.13Z",
    transform: "translate(-264.54 -251.057)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.689 22.077)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M276.572,272.7c0,1.479-1.038,2.079-2.32,1.338a5.129,5.129,0,0,1-2.32-4.017c0-1.48,1.039-2.079,2.32-1.34A5.126,5.126,0,0,1,276.572,272.7Z",
    transform: "translate(-271.932 -268.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M281.934,275.792c0,1.48-1.039,2.079-2.32,1.34a5.126,5.126,0,0,1-2.32-4.019c0-1.479,1.038-2.079,2.32-1.338A5.129,5.129,0,0,1,281.934,275.792Z",
    transform: "translate(-270.266 -267.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M287.3,278.888c0,1.479-1.039,2.079-2.32,1.338a5.124,5.124,0,0,1-2.32-4.017c0-1.48,1.038-2.079,2.32-1.34A5.131,5.131,0,0,1,287.3,278.888Z",
    transform: "translate(-268.6 -266.438)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.916 195.702)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M493.443,436.068l5.173-47.227,24.308-14.422-5.16,47.125Z",
    transform: "translate(-415.247 -374.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M521,375.248c2.237,4.5,3.163,12.669,2.128,22.089-1.013,9.243-3.663,17.468-6.837,22.307l-22.473,13.04L498.7,388.2l21.752-12.6.065-.035.142-.082v-.005Z",
    transform: "translate(-414.595 -372.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M498.716,379.984c2.251,4.5,3.182,12.683,2.147,22.13s-3.78,17.832-7.049,22.625Z",
    transform: "translate(-414.609 -364.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M483.863,441.669l5.173-47.226,24.308-14.423-5.16,47.127Z",
    transform: "translate(-431.741 -364.779)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M511.42,380.847c2.237,4.5,3.163,12.672,2.131,22.092-1.012,9.243-3.663,17.468-6.837,22.3l-22.473,13.042,4.872-44.483,21.752-12.6.068-.038.142-.084v0C511.189,381,511.306,380.926,511.42,380.847Z",
    transform: "translate(-431.088 -363.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M489.136,385.584c2.251,4.493,3.182,12.683,2.145,22.13s-3.778,17.832-7.046,22.625Z",
    transform: "translate(-431.102 -355.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M474.288,447.255l5.173-47.226,24.308-14.422-5.162,47.127Z",
    transform: "translate(-448.226 -355.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M501.846,386.434c2.237,4.5,3.16,12.669,2.128,22.089-1.012,9.243-3.663,17.468-6.837,22.307l-22.47,13.039,4.872-44.483,21.752-12.6.068-.038.139-.084v0C501.614,386.589,501.731,386.51,501.846,386.434Z",
    transform: "translate(-447.573 -353.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M479.56,391.17c2.251,4.5,3.184,12.683,2.147,22.13s-3.78,17.832-7.049,22.623Z",
    transform: "translate(-447.589 -345.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M464.712,452.841l5.173-47.226,24.306-14.423-5.16,47.128Z",
    transform: "translate(-464.712 -345.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M492.272,392.02c2.237,4.5,3.16,12.669,2.128,22.092-1.013,9.243-3.663,17.465-6.837,22.3l-22.473,13.042,4.872-44.486,21.751-12.6.065-.038.144-.082v-.005C492.041,392.175,492.158,392.1,492.272,392.02Z",
    transform: "translate(-464.06 -344.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M469.982,396.757c2.254,4.493,3.182,12.683,2.15,22.13s-3.78,17.83-7.049,22.623Z",
    transform: "translate(-464.074 -335.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M469.14,425.431l.15-1.383a15.917,15.917,0,0,1,1.032-3.982,51.413,51.413,0,0,1,2.444-5.217c.041-.076.446-.833,1.206-2.264s1.315-2.444,1.657-3.021a14.292,14.292,0,0,0,1.611-5.359c.22-2.006-.122-2.743-1.018-2.213a3.774,3.774,0,0,0-1.573,2.5,14.326,14.326,0,0,0-.31,1.864l-.327,2.964-3.593,2.123.158-1.437a19.781,19.781,0,0,1,1.505-6.38,10.527,10.527,0,0,1,2.6-3.361,14.584,14.584,0,0,1,2.063-1.445,4.922,4.922,0,0,1,2.09-.768,1.516,1.516,0,0,1,1.331.531c.607.746.8,2.063.6,3.955a16.9,16.9,0,0,1-1.712,5.664c-.931,1.889-1.834,3.606-2.722,5.166a38.6,38.6,0,0,0-3.3,7.161l5.7-3.369-.308,2.79Z",
    transform: "translate(-457.089 -333.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M478.744,419.185l2.583-23.583,3.719-2.2-1.393,12.718,4.587-11.192,3.776-2.234-5.13,12.208,3.186,7.584-3.791,2.241-2.781-7.214-1.038,9.474Z",
    transform: "translate(-440.554 -342.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M492.957,412.372q-4.9,2.9-4.374-1.924l.321-2.934,3.53-2.087-.283,2.564c-.117,1.078.03,1.619.438,1.614a1.86,1.86,0,0,0,.781-.321l.087-.052a3.751,3.751,0,0,0,1.489-3.032l.656-5.982a3.812,3.812,0,0,0-.074-1.736q-.212-.465-1.023.016a3.854,3.854,0,0,0-1.712,3.135l-3.3,1.829L490.8,391.53l9.139-5.408-.351,3.19-5.672,3.356-.523,4.744a5.345,5.345,0,0,1,1.051-1.369,8.175,8.175,0,0,1,1.559-1.206q2.164-1.278,2.809.024c.427.865.5,2.6.215,5.212a42.125,42.125,0,0,1-.879,5.607,12.229,12.229,0,0,1-1.108,2.822A10.964,10.964,0,0,1,492.957,412.372Z",
    transform: "translate(-423.702 -354.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M499.2,391.068q.535-4.891,5.506-7.827,2.47-1.466,3.47-.808t.659,3.767l-.117,1.089-3.334,1.971.144-1.317a3.587,3.587,0,0,0-.1-1.823q-.253-.461-1-.022a3.479,3.479,0,0,0-1.157,1.072,3.692,3.692,0,0,0-.509,1.619,1.73,1.73,0,0,0,1.165,2.055l1.8.536q2.78.894,2.425,4.148a9.849,9.849,0,0,1-1.641,4.545,12.057,12.057,0,0,1-3.93,3.522q-2.572,1.523-3.639.855c-.713-.449-.958-1.69-.735-3.737l.142-1.29,3.492-2.066-.174,1.609c-.193,1.774.188,2.373,1.143,1.81a3.135,3.135,0,0,0,1.148-1.121,4.619,4.619,0,0,0,.512-1.8,2.128,2.128,0,0,0-1.532-2.55c-.035-.011-.308-.09-.822-.237s-.814-.231-.9-.261C499.655,394.333,498.98,393.084,499.2,391.068Z",
    transform: "translate(-407.173 -360.977)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRecovery);
export default __webpack_public_path__ + "static/media/image-recovery.fb1098b1e2c7a1ff85ff7594ead06a10.svg";
export { ForwardRef as ReactComponent };